import DownloadSection from "./downloadSection/DownloadSection";
import FooterSection from "./footer/FooterSection";
import Hero from "./hero/Hero";
import MobileFeature from "./mobileFeature/MobileFeature";
import WhySection from "./whySection/WhySection";
import Navbar from "./navbar/Navbar";
import QuestionSection from "./questionSection/QuestionSection";
import { useEffect } from "react";
import { useLocation } from "react-router";

const PublicLayout = () => {
  const location = useLocation();

  useEffect(() => {
    // URL example: /#footer
    if (location.hash === "#footer") {
      const footer = document.getElementById("footer");
      if (footer) {
        footer.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div>
      <Navbar />
      <Hero />
      <MobileFeature />
      <DownloadSection />
      <WhySection />
      <QuestionSection />
      <FooterSection />
    </div>
  )
}

export default PublicLayout;
